import { Model } from 'modules/core/lib/mobx-rest'

export const ALLOWED_COUNTRIES: { [key: string]: string } = {
  spain: 'es',
  france: 'fr',
  mexico: 'mx',
  other: 'other',
}

export type Country = keyof typeof ALLOWED_COUNTRIES

interface IPayrollBundle {
  country: Country
  bookkeeper_id: number
  company_id: number
}

class PayrollBundle extends Model<IPayrollBundle> {
  static urlRoot() {
    return '/bundles/payroll'
  }
}

export default PayrollBundle
